import { A02, A02Output as GetLineLinkUrlResponse } from 'api/U013';

type UseGetLineLinkUrlType = {
  getLineLinkUrl: (
    userId: string,
    revision: number,
    linkToken: string
  ) => Promise<GetLineLinkUrlResponse | null>;
};

export function useGetLineLinkUrl(): UseGetLineLinkUrlType {
  const getLineLinkUrl = async (userId: string, revision: number, linkToken: string) => {
    try {
      const data = await A02(userId, revision, linkToken);
      return data;
    } catch (err: unknown) {
      console.error(err);
      return null;
    }
  };

  return { getLineLinkUrl };
}
